export default __webpack_public_path__ + "static/media/star1.82fbe0a7.svg";